import { createContext } from 'react';

const FacebookContext = createContext();

export default FacebookContext;